import { useParams } from "react-router-dom";
import Layout from "../layout";
import { TrainingsProvider } from "@my-helpers/common";
import TrainingView from "./training";
import TrainingsView from "./trainings";

const Trainings = () => {
    const { id } = useParams<{ id: string }>();

	return (
		<Layout>
			<TrainingsProvider trainingId={id} >
                {
                    id ? 
                    <TrainingView /> :
                    <TrainingsView />
                }
			</TrainingsProvider>
		</Layout>
	);
};

export default Trainings;